import { firebase } from "@firebase/app";
import "@firebase/firestore";
import "@firebase/analytics";
import "@firebase/auth";


const firebaseApp = firebase.initializeApp({
    apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
    authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCK,
    messagingSenderId: process.env.VUE_APP_FIREBASE_SENDER,
    appId: process.env.VUE_APP_FIREBASE_APPID,
    measurementId: "G-D5XMQSJGZV"
  });

firebase.analytics();


 export const db = firebaseApp.firestore();
